/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ModelVersionHierarchy } from '../../models/model-version-hierarchy';
import { UpdateModelVersionCommand } from '../../models/update-model-version-command';

export interface ApiAdminModelVersionsVersionIdPut$Params {
  versionId: string;
      body?: UpdateModelVersionCommand
}

export function apiAdminModelVersionsVersionIdPut(http: HttpClient, rootUrl: string, params: ApiAdminModelVersionsVersionIdPut$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelVersionHierarchy>> {
  const rb = new RequestBuilder(rootUrl, apiAdminModelVersionsVersionIdPut.PATH, 'put');
  if (params) {
    rb.path('versionId', params.versionId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelVersionHierarchy>;
    })
  );
}

apiAdminModelVersionsVersionIdPut.PATH = '/api/Admin/model-versions/{versionId}';
